import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { GetTariffsResponse } from './types/express'

type ApiGetTariffsResponse = Promise<AxiosResponse<GetTariffsResponse>>

export function getList(page: number): ApiGetTariffsResponse {
    return http.get('/delivery/api/billing/tariff', { params: { page } })
}

export default {
    getList,
}
